import { ReactNode, useMemo } from 'react';
import { SidePanelPersonalizationContext } from './context';
import { useSidePanelPersonalization } from './hooks/use-side-panel-personalization';
import { SidePanelSurfaceConfig } from './model/descriptors';

/** shares one view-model instance between the properties panel, the modal, and the cards */
export const SidePanelPersonalizationProvider = ({
  surface,
  children,
}: {
  surface: SidePanelSurfaceConfig;
  children: ReactNode;
}) => {
  const viewModel = useSidePanelPersonalization(surface);

  const value = useMemo(() => ({ surface, viewModel }), [surface, viewModel]);

  return (
    <SidePanelPersonalizationContext.Provider value={value}>
      {children}
    </SidePanelPersonalizationContext.Provider>
  );
};
